import { Grid } from '@mui/material';
import { CustomerAutocomplete } from 'new/customer-autocomplete';
import { CustomerShipToDropdown } from 'new/customer-ship-to-dropdown';
import { CustomerTypeDropdown } from 'new/customer-type-dropdown';
import { SalesRepDropDown } from 'new/salesrep-dropdown';
import { ToggleCompetition } from 'new/toggle-competition';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { defaultCustomer, salesLocationOptions } from 'shared/constants';
import { useNewQuoteState } from 'shared/contexts';
import { DropdownField, FormTextField } from 'shared/controls';
interface CustomerInfoProps {
  loggedInUserId: string;
  brand: string;
}
export function CustomerInfo({ loggedInUserId, brand }: CustomerInfoProps) {
  const {
    watch,
    setValue,
    formState: { errors },
  } = useFormContext();
  const { toggleDialog } = useNewQuoteState();
  const isCimtec: boolean = brand === 'cimtec';
  const excluded = watch('customer.isExcluded');
  const isNew = watch('customer.isNew');

  useEffect(() => {
    if (excluded) {
      toggleDialog();
      setValue('customer', defaultCustomer);
    }
  }, [excluded, setValue, toggleDialog]);

  return (
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <SalesRepDropDown loggedInUserId={loggedInUserId} />
      </Grid>
      {isCimtec && (
        <Grid item xs={12}>
          <DropdownField
            name='salesLocation'
            label='Sales Location'
            rules={{ required: { message: 'Sales Location is required', value: true } }}
            error={Boolean(errors?.salesLocation)}
            helperText={errors?.salesLocation?.message}
            options={salesLocationOptions}
          />
        </Grid>
      )}
      <Grid item xs={12}>
        <CustomerAutocomplete />
      </Grid>
      {isNew && (
        <Grid item xs={12}>
          <FormTextField
            name='customer.customerNumber'
            label='Customer Number'
            rules={{ required: { message: 'Customer Number is required', value: true } }}
            error={Boolean(errors?.customer?.customerNumber)}
            helperText={errors?.customer?.customerNumber?.message}
          />
        </Grid>
      )}
      <Grid item xs={12}>
        <CustomerShipToDropdown />
      </Grid>
      <Grid item xs={12}>
        <CustomerTypeDropdown />
      </Grid>
      <Grid item xs={12}>
        <ToggleCompetition />
      </Grid>
    </Grid>
  );
}
